import type { AWXEntity } from '@ankor-io/common/types/awx'

import { Button } from '@/ui-components/Button'
import { DialogActions, DialogBody } from '@/ui-components/Dialog'
import { Input } from '@/ui-components/Input'
import { Select } from '@/ui-components/Select'

export const Step2CreateConnectedAccount = ({
  onBack,
  entryType,
  selectedEntity,
  newEntityName,
  isLoading,
  connectedAccountName,
  setConnectedAccountName,
  onCreate,
}: {
  onBack: () => void
  entryType: 'existing' | 'new'
  selectedEntity: AWXEntity | null
  newEntityName: string
  setNewEntityName: (value: string) => void
  isLoading: boolean
  connectedAccountName: string
  setConnectedAccountName: (value: string) => void
  onCreate: () => void
}) => {
  return (
    <>
      <DialogBody>
        <div className="space-y-6">
          {entryType === 'existing' ? (
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-900 dark:text-white">Custom Entity</label>
              <Select
                value={selectedEntity?.id}
                disabled
              >
                <option value="">{selectedEntity?.name}</option>
              </Select>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium mb-2 text-gray-900 dark:text-white">New Entity Name</label>
              <Input
                value={newEntityName}
                readOnly
              />
            </div>
          )}
          <div>
            <label className="block text-sm font-medium mb-2 text-gray-900 dark:text-white">Vessel name</label>
            <Input
              placeholder="Enter vessel name"
              value={connectedAccountName}
              onChange={(e) => setConnectedAccountName(e.target.value)}
            />
          </div>
        </div>
      </DialogBody>
      <DialogActions>
        <Button
          plain
          onClick={onBack}
          disabled={isLoading}
          className="disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Back
        </Button>
        <Button
          color="primary"
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={onCreate}
          disabled={!connectedAccountName || isLoading}
          data-testid="step2-next-button"
        >
          Create
        </Button>
      </DialogActions>
    </>
  )
}
